import React, { useContext } from 'react';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
dayjs.extend(advancedFormat);

import { IAuctionSummaryProps } from 'src/pages/CatalogPage/components/AuctionSummary/AuctionSummary.i';
import {
  AuctionSummaryContainer,
  PreviewDay,
  AuctionSessionContainer,
  AuctionSessions,
  AuctionExcerpt,
  ContactInfo,
} from 'src/pages/CatalogPage/components/AuctionSummary/AuctionSummary.style';
import { TextButton } from '@riac/design-system';
import { CatalogContext } from 'src/pages/CatalogPage/CatalogPage';

export const AuctionSummary = (props: IAuctionSummaryProps): JSX.Element => {
  const sessions = props.sessions.filter((sess) => sess.value != 'All');
  const {auctionId} = useContext(CatalogContext);

  const previewDate = dayjs(props.auctionStartDate).subtract(1, 'day').format('dddd, MMM Do');
  let previewStartTime = '10:00 AM'; // (props.auctionTypeID == 1) ? '10:00 AM' : '9:00 AM';
  let previewEndTime = '6:00 PM';

  const auctionStartTime = dayjs(props.auctionStartTime, 'HH:mm:ss').format('h A');

  if(auctionId === 2094) {
    previewStartTime = '11:00 AM';
    previewEndTime = '4:00 PM';
  }

  return (
    <AuctionSummaryContainer>
      <PreviewDay>
        <header>Preview Day</header>
        <p>
          {previewDate}
        </p>
        <p>
          {previewStartTime} - {previewEndTime}
        </p>
      </PreviewDay>
      <AuctionSessions>
        {sessions.map( (session, index) => {
          return <AuctionSession
            sessionRomanNumeral = {intToRoman(index + 1)}
            dateString = {session.name}
            startTime = {auctionStartTime}
            startingLot = {session.startingLot}
            endingLot = {session.endingLot}
            key = {session.value}
          />;
        })}
      </AuctionSessions>
      <AuctionExcerpt dangerouslySetInnerHTML = {{ __html: props.auctionExcerpt }}/>

      <ContactInfo>
        <p>Phone: <TextButton to="tel:13097971500">1-309-797-1500</TextButton></p>
        <p>Toll-Free: <TextButton to="tel:18002388022">1-800-238-8022</TextButton></p>
        <p>Email: <TextButton to="mailto:info@rockislandauction.com">info@rockislandauction.com</TextButton></p>
        <p>Rock Island Auction Company - {props.locationCity}</p>
        <p>{props.locationAddress}</p>
        <p>{props.locationCity}, {props.locationState}, {props.locationZip}, USA</p>
      </ContactInfo>
    </AuctionSummaryContainer>
  );
};

const AuctionSession = (props) => {
  return (
    <AuctionSessionContainer>
      <header>SESSION {props.sessionRomanNumeral}</header>
      <p>
        {props.dateString} at {props.startTime}
      </p>
      <p>
        Lots {props.startingLot} through {props.endingLot}
      </p>
    </AuctionSessionContainer>
  );
};

const intToRoman = (num) => {
  const map = {
    M: 1000,
    CM: 900,
    D: 500,
    CD: 400,
    C: 100,
    XC: 90,
    L: 50,
    XL: 40,
    X: 10,
    IX: 9,
    V: 5,
    IV: 4,
    I: 1,
  };
  let result = '';

  for(const key in map) {
    const repeatCounter = Math.floor(num / map[key]);

    if(repeatCounter !== 0) {
      result += key.repeat(repeatCounter);
    }

    num %= map[key];

    if(num === 0) return result;
  }

  return result;
};
